import { useEffect, useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesOverview from './components/ServicesOverview';
import StatsSection from './components/StatsSection';
import WhyChooseUs from './components/WhyChooseUs';
import CTASection from './components/CTASection';

const HomePage = () => {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <HeroSection scrollY={scrollY} />
      <ServicesOverview />
      <StatsSection />
      <WhyChooseUs />
      <CTASection />
      <Footer />
    </div>
  );
};

export default HomePage;
